<template>
    <element-overlay :data="data"
                     :layer-height="layerHeight"
                     :layer-width="layerWidth"
                     :show-element-icon="showElementIcon"
                     :show-element-state="showElementState">
        <component :is="componentName"
                   v-if="supportedElementTypes[dataComputed.type]"
                   :data="dataComputed"
                   :sizeRatio="sizeRatio"
                   class="element-preview-fullsize"
                   v-bind="sizeProps" />
        <div v-else
             class="element-preview-fullsize">
            {{ dataComputed.type }}
        </div>
    </element-overlay>
</template>

<script>
import clockPreview from '../clock.vue'
import dayPreview from '../day.vue'
import emptyrectanglePreview from './elementTypes/emptyrectangle.vue'
import picturePreview from './elementTypes/picture.vue'
import rssfeedPreview from '../rssfeed.vue'
import textPreview from '../text.vue'
import widgetPreview from './elementTypes/widget.vue'

import staticIconPreview from './elementTypes/staticIconPreview.vue'
import ElementOverlay from './elementOverlay.vue'

const supportedElementTypes = {
    campaign: true,
    clock: true,
    countdown: true,
    day: true,
    emptyrectangle: true,
    esign: true,
    iframe: true,
    layer: true,
    pdf: true,
    picture: true,
    ppt: true,
    rssfeed: true,
    streaming: true,
    template: true,
    text: true,
    video: true,
    widget: true,
    youtube: true
}

export default {
    name: 'elementPreviewV2',
    components: {
        ElementOverlay,
        clockPreview,
        dayPreview,
        emptyrectanglePreview,
        picturePreview,
        textPreview,
        rssfeedPreview,
        widgetPreview,
        staticIconPreview
    },
    inject: {
        /** @type {PublishInjectInfoTable} */
        publishInfoTable: {
            default: {}
        }
    },
    props: {
        /*/!** @type {PublishElementData} *!/*/
        /** @type {PublishElementDataCommon} */
        data: Object,
        previewHeight: Number,
        /** @type {number | null} - Computed sizeRatio or null if height property was not available */
        sizeRatio: Number,
        aspectRatio: Number,
        layerWidth: Number,
        layerHeight: Number,
        showElementIcon: {
            type: Boolean,
            default: true
        },
        showElementState: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            supportedElementTypes: supportedElementTypes
        }
    },
    computed: {
        componentName() {
            switch (this.dataComputed.type) {
                case 'countdown':
                case 'esign':
                case 'iframe':
                case 'layer':
                case 'pdf':
                case 'ppt':
                case 'streaming':
                case 'youtube':
                    return 'staticIconPreview'

                case 'campaign':
                case 'video':
                case 'template':
                    return 'picturePreview'

                default:
                    return `${this.dataComputed.type}Preview`
            }
        },
        sizeProps() {
            switch (this.dataComputed.type) {
                case 'text':
                    return {
                        width: this.previewHeight * this.aspectRatioComputed,
                        height: this.previewHeight,
                        frame: {
                            ratio: this.sizeRatio
                        }
                    }

                case 'rssfeed':
                case 'widget':
                    return {
                        width: this.layerWidthComputed,
                        height: this.layerHeightComputed,
                        frame: {
                            ratio: this.sizeRatio
                        }
                    }

                default:
                    return undefined
            }
        },
        dataComputed() {
            return this.data ?? this.publishInfoTable.element?.data
        },
        aspectRatioComputed() {
            return this.aspectRatio ?? this.publishInfoTable.layer?.aspectRatio
        },
        layerWidthComputed() {
            return this.layerWidth ?? this.publishInfoTable.layer?.width
        },
        layerHeightComputed() {
            return this.layerHeight ?? this.publishInfoTable.layer?.height
        }
    }
}
</script>
